import DateCondition from './DateCondition'
import MonthCondition from './MonthCondition'
import TypeCondition from './TypeCondition'
import DateSelect from './DateSelect'

export default {
	name: 'SearchCondition',
	components: {
		DateCondition,
		MonthCondition,
		TypeCondition,
		DateSelect
	},
	props: {
		value: {
			type: Object
		},
		leaseTimeClasses: {
			type: Array,
			default: []
		},
		carTypes: {
			type: Array,
			default: []
		}
	},
	data () {
		const val = { ...this.value }
		const dateEnabled = val.dateFrom && val.dateTo && val.timeFrom && val.timeTo
		const monthEnabled = !dateEnabled && !!val.month
		return {
			val,
			dateEnabled,
			monthEnabled
		}
	},
	template: `
		<div>
			<div class="search-row -space-s">
				<div class="search-row__left">
					<h3 class="search-sub -sp-space">貸出期間</h3>
				</div>
				<DateCondition :class="{ 'search-cond-disabled': !dateEnabled }"
					v-model="val"
					@controlClick="dateEnabled = true; monthEnabled = false"
				/>
			</div>

			<div class="search-row -space-l">
				<div class="search-row__left"></div>
				<dl class="search-data -sp-no-left"
					:class="{ 'search-cond-disabled': !monthEnabled }"
				>
					<dt class="search-data__ttl-left">月指定</dt>
					<dd>
						<div class="m-sch">
							<DateSelect v-model="val.dateFrom"
								@controlClick="dateEnabled = false; monthEnabled = true"
							/>
						</div>
						<span class="search-data__while">~</span>
						<div class="m-sch">
							<MonthCondition
								v-model="val.month"
								@controlClick="dateEnabled = false; monthEnabled = true"
								:timeClasses="leaseTimeClasses"
							/>
						</div>
					</dd>
				</dl>
			</div>

			<div class="search-row -space-m">
				<div class="search-row__left">
					<h3 class="search-sub -sp-space">車両タイプ</h3>
				</div>
				<div class="search-block">
					<TypeCondition v-model="val.type" :carTypes="carTypes" />
					<ul class="search-btn-list">
						<li><button type="submit" class="m-btn-02 -jp -pc-high -sp-low -sp-font-m" :disabled="!filled">検索</button></li>
						<li><button type="button" class="search-clear" @click="clear">条件クリア</button></li>
					</ul>
				</div>
			</div>

			<input type="hidden"
				v-for="pair in condition"
				:key="pair.name"
				:name="pair.name"
				:value="pair.value"
			/>
		</div>
	`,
	methods: {
		clear () {
			const { val } = this
			val.dateFrom = null
			val.dateTo = null
			val.timeFrom = null
			val.timeTo = null
			val.month = null
			this.dateEnabled = false
			this.monthEnabled = false
		}
	},
	computed: {
		condition () {
			const { val } = this
			const cond = {}
			if (!this.dateEnabled && !this.monthEnabled) return null
			if (this.dateEnabled) {
				cond.dateFrom = val.dateFrom
				cond.timeFrom = val.timeFrom
				cond.dateTo = val.dateTo
				cond.timeTo = val.timeTo
			} else if (this.monthEnabled) {
				cond.dateFrom = val.dateFrom
				cond.month = val.month
			}
			if (val.type) {
				cond.type = val.type
			}
			return Object.keys(cond).map(key => {
				return {
					name: key,
					value: cond[key]
				}
			})
		},
		filled () {
			const { val } = this
			if (this.dateEnabled) {
				return val.dateFrom && val.dateTo && val.timeFrom && val.timeTo
			} else if (this.monthEnabled) {
				return val.dateFrom && val.month
			} else {
				return false
			}
		}
	},
	watch: {
		val () {
			this.$emit('input', this.val)
			console.log('SearchCondition.val updated')
		}
	}
}
